export { default } from './ListItemAvatar';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ListItemAvatar/index.js
// module id = 339
// module chunks = 0